import React from "react"
import Blognavbar from "../Components/blognavbar"
import BlogFooter from "../Components/blogfooter"
import "../Styles/blog.scss"
import Post from "../Components/post"
import { graphql, StaticQuery } from "gatsby"
import { Row, Col } from "react-bootstrap"
import { fab } from "../../node_modules/@fortawesome/free-brands-svg-icons"

import { library } from "../../node_modules/@fortawesome/fontawesome-svg-core";
import {
  faHashtag,
  faEnvelope,
  faPhone,
} from "../../node_modules/@fortawesome/free-solid-svg-icons"
library.add(fab, faHashtag, faEnvelope, faPhone);

function postrender() {
  return (
    <div className="posts">
      <StaticQuery
        query={blogquery}
        render={data => {
          return (
            <div className="blog-posts">
              
              <Row className="justify-content-md-center blog-posts-sec">
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="blog-posts-sec-title">
                  <h1>NEWS</h1>
                </Col>
                
                {data.allMarkdownRemark.edges.map(({ node }) => (
                  <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                    <Post
                      key={node.id}
                      title={node.frontmatter.title}
                      date={node.frontmatter.date}
                      slug={node.fields.slug}
                      body={node.excerpt}
                      fluid={node.frontmatter.image.childImageSharp.fluid}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          )
        }}
      />
    </div>
  )
}

const Newspage = () => {
  return (
    <div className="blog-body">
      <Blognavbar></Blognavbar>
      <div className="all-posts">{postrender()}</div>
      <BlogFooter></BlogFooter>
    </div>
  )
}
const blogquery = graphql`
  query 
    {
        allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}, filter: {frontmatter: {cat: {eq: "news"}}}) {
          edges {
            node {
              id
              frontmatter {
                title
                date
                image {
                    childImageSharp {
                      fluid(maxWidth: 600) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                cat
              }
              excerpt(truncate: true)
              fields {
                slug
              }
            }
          }
        }
      }
  
`

export default Newspage
